import { dayjs } from 'services/dayjs';
import { User } from 'services/interface';
import { isInOrganization } from 'services/accessControl';

export const getExpiredLicenseStatus = (user: User | null): boolean => {
    if (user?.paid_user !== 1) {
        return false;
    }

    const expirationDate = isInOrganization(user) ? user?.organization?.expiration_date : user?.expiration_date;

    const isExpired = Boolean(expirationDate) && dayjs(expirationDate).isBefore(dayjs());

    return isExpired;
};
